export default __webpack_public_path__ + "static/Meire D_Origem_MiniBio-8d4e7113b9954608b9802aa16a6d8d1e.webp";